type BadgeShape = 'circle' | 'square'

interface BadgeProps {
  initials: string
  /** Hex colour value — used as inline background-color */
  color?: string
  /** Tailwind bg-* class — takes precedence over `color` when provided */
  colorClass?: string
  shape?: BadgeShape
  className?: string
}

const shapeClasses: Record<BadgeShape, string> = {
  circle: 'rounded-full w-9 h-9',
  square: 'rounded-lg w-10 h-10 border-2 border-ink dark:border-dark-border',
}

export function Badge({
  initials,
  color = '#1e3a5f',
  colorClass,
  shape = 'circle',
  className = '',
}: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center justify-center text-white text-sm font-bold shrink-0 ${shapeClasses[shape]} ${colorClass ?? ''} ${className}`}
      style={colorClass ? undefined : { backgroundColor: color }}
      aria-hidden="true"
    >
      {initials.slice(0, 2).toUpperCase()}
    </span>
  )
}
